module.exports = __webpack_public_path__ + "img/16_peaceJusticeAndStrongInstitutions.a7d4e60b.png";